/* eslint-disable react/prop-types */ // TODO: add props
import { NavLink } from 'react-router-dom';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import _ from 'lodash';
import cx from 'classnames';
import s from './styles.scss';
import { IconQuestion, IconActivity } from './icons';

function padLeft(string, pad, length) {
  return (new Array(length + 1).join(pad) + string).slice(-length);
}

function getHumanDuration(seconds) {
  const minutes = Math.floor(seconds / 60);
  const remaining = Math.floor(seconds % 60);
  return `${minutes}:${padLeft(remaining, '0', 2)}`;
}

const LessonNavLink = ({ chunk, url, hasChunkVisit = false }) => {
  const duration = chunk.getIn(['video', 'duration']);

  const tooltip = (
    <Tooltip id={_.uniqueId()}>
      {chunk.get('title_with_knowledge_unit_serial')}&nbsp;
      {duration ? <span>({getHumanDuration(duration)})</span> : null}
    </Tooltip>
  );

  return (
    <OverlayTrigger placement="bottom" overlay={tooltip}>
      <NavLink
        className={cx({ [s.hasChunkVisit]: hasChunkVisit })}
        activeClassName={s.active}
        to={url}
      >
        {!chunk.get('activity') && chunk.get('question') && <IconQuestion />}
        {!chunk.get('question') && chunk.get('activity') && <IconActivity />}
      </NavLink>
    </OverlayTrigger>
  );
};

export default LessonNavLink;
